import { useEffect } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { refreshAutoLanguageFromDevice } from "@/i18n/config";

export default function DeviceLanguageSync() {
  useEffect(() => {
    let active = true;
    let removeNativeListener: (() => Promise<void>) | undefined;
    const sync = () => {
      void refreshAutoLanguageFromDevice().catch((error) => {
        console.warn("[i18n] Device language refresh failed", error);
      });
    };

    window.addEventListener("languagechange", sync);
    sync();

    if (Capacitor.isNativePlatform()) {
      void App.addListener("appStateChange", ({ isActive }) => {
        if (isActive) sync();
      }).then((handle) => {
        if (active) removeNativeListener = () => handle.remove();
        else void handle.remove();
      });
    }

    return () => {
      active = false;
      window.removeEventListener("languagechange", sync);
      if (removeNativeListener) void removeNativeListener();
    };
  }, []);

  return null;
}
